/**
 * Track Page View Event
 */
import { sha256 } from 'js-sha256';

import { isVppnAsync } from 'main/auth/provider';

import {
	getCleanPath,
	getSiteSection,
	getViewName,
	isErrorPath,
	isHomePage,
	logDebug,
	pushToAdobeDataLayer,
	waitForUserAsync,
} from './utils';

export const trackPageView = async (): Promise<void> => {
	logDebug('Tracking page view...');
	const user = await waitForUserAsync();
	const isVppn = await isVppnAsync();
	const customer = user?.customer;
	const userIdHash = user?.userId
		? sha256(user.userId.toString())
		: undefined;
	const customerIdHash = customer?.id
		? sha256(customer.id.toString())
		: undefined;
	const currentPathname = window.location.pathname;
	const cleanPath = getCleanPath(currentPathname);
	const payload = {
		event: 'pageView',
		_volvo: {
			universal: {
				generic: {
					brand: {
						name: 'Volvo Penta',
						type: 'Market',
						identifier: 'vp-product-center',
					},
					user: user
						? {
								type: isVppn ? 'external' : 'internal',
								role:
									user.roles?.map((r) => r.name).join(',') ??
									undefined,
								loginStatus: !!user,
							}
						: undefined,
					company: customer
						? {
								id: customer.id?.toString() ?? undefined,
								idSHA256: customerIdHash,
								name: customer.customerName ?? undefined,
								country: customer.customerCountry ?? undefined,
							}
						: undefined,
				},
				identity: user?.userId
					? { uid: user.userId, uidSHA256: userIdHash }
					: undefined,
				web: {
					page: {
						category: 'Application',
						language: user?.language?.split('-')[0] ?? 'en',
						country: customer?.customerCountry ?? 'US',
					},
				},
			},
		},
		application: {
			version: `${import.meta.env.VITE_BUILD_VERSION ?? 'unknown'} build ${import.meta.env.VITE_DEPLOYMENT_DATE ?? 'unknown'}`,
		},
		web: {
			webPageDetails: {
				URL: `${window.location.origin}${currentPathname}${window.location.search}`,
				isErrorPage: isErrorPath(cleanPath),
				isHomePage: isHomePage(cleanPath),
				name: document.title ?? 'Product Center',
				server: window.location.host,
				siteSection: getSiteSection(cleanPath),
				viewName: getViewName(cleanPath),
				pageViews: { value: 1 },
			},
		},
	};
	void pushToAdobeDataLayer(payload);
};
